import Layout from '@/layout';
var distributionRouter = {
  path: '/distribution',
  component: Layout,
  redirect: '/distribution/promoter-management/promoters',
  name: 'Distribution',
  meta: {
    title: '淘客管理',
    icon: 'clipboard'
  },
  children: [{
    path: 'promoter-management',
    component: function component() {
      return import('@/views/distribution/alliance/ParentView');
    },
    redirect: '/distribution/promoter-management/promoters',
    name: 'DistributionPromoterManagement',
    meta: {
      title: '淘客管理',
      icon: ''
    },
    children: [{
      path: 'promoters',
      component: function component() {
        return import('@/views/distribution/alliance/promoter-center/index');
      },
      name: 'DistributionPromoterList',
      meta: {
        title: '淘客列表',
        icon: ''
      }
    }, {
      path: 'settings',
      component: function component() {
        return import('@/views/distribution/alliance/config/index');
      },
      name: 'DistributionSettings',
      meta: {
        title: '淘客设置',
        icon: ''
      }
    }, {
      path: 'withdrawals',
      component: function component() {
        return import('@/views/distribution/alliance/withdraw/index');
      },
      name: 'DistributionPromoterWithdrawals',
      meta: {
        title: '淘客提现申请',
        icon: '',
        accountRole: 'PROMOTER'
      }
    }]
  }, {
    path: 'leader-management',
    component: function component() {
      return import('@/views/distribution/alliance/ParentView');
    },
    redirect: '/distribution/leader-management/leaders',
    name: 'DistributionLeaderManagement',
    meta: {
      title: '团长管理',
      icon: ''
    },
    children: [{
      path: 'leaders',
      component: function component() {
        return import('@/views/distribution/alliance/leader/index');
      },
      name: 'DistributionLeaderList',
      meta: {
        title: '团长列表',
        icon: ''
      }
    }, {
      path: 'verify-limit',
      component: function component() {
        return import('@/views/distribution/alliance/verify-limit/index');
      },
      name: 'DistributionLeaderVerifyLimit',
      meta: {
        title: '积分核销限额',
        icon: ''
      }
    }, {
      path: 'verify-records',
      component: function component() {
        return import('@/views/distribution/alliance/verify/index');
      },
      name: 'DistributionLeaderVerifyRecords',
      meta: {
        title: '积分核销记录',
        icon: ''
      }
    }, {
      path: 'withdrawals',
      component: function component() {
        return import('@/views/distribution/alliance/withdraw/index');
      },
      name: 'DistributionLeaderWithdrawals',
      meta: {
        title: '团长提现申请',
        icon: '',
        accountRole: 'LEADER'
      }
    }]
  }, {
    path: 'agent-management',
    component: function component() {
      return import('@/views/distribution/alliance/ParentView');
    },
    redirect: '/distribution/agent-management/regions',
    name: 'DistributionAgentManagement',
    meta: {
      title: '代理',
      icon: ''
    },
    children: [{
      path: 'regions',
      component: function component() {
        return import('@/views/distribution/alliance/region/index');
      },
      name: 'DistributionRegionAgents',
      meta: {
        title: '区域与代理',
        icon: ''
      }
    }, {
      path: 'profits',
      component: function component() {
        return import('@/views/distribution/alliance/agent-profit/index');
      },
      name: 'DistributionAgentProfits',
      meta: {
        title: '代理利润分成',
        icon: ''
      }
    }]
  }, {
    path: 'zone-management',
    component: function component() {
      return import('@/views/distribution/alliance/ParentView');
    },
    redirect: '/distribution/zone-management/stores',
    name: 'DistributionZoneManagement',
    meta: {
      title: '门店专区',
      icon: ''
    },
    children: [{
      path: 'stores',
      component: function component() {
        return import('@/views/distribution/storeManage/index');
      },
      name: 'DistributionStoreManagement',
      meta: {
        title: '门店管理',
        icon: ''
      }
    }, {
      path: 'products',
      component: function component() {
        return import('@/views/distribution/alliance/distribution-product/index');
      },
      name: 'DistributionZoneProducts',
      meta: {
        title: '淘客商品',
        icon: ''
      }
    }, {
      path: 'points',
      component: function component() {
        return import('@/views/distribution/alliance/points/index');
      },
      name: 'DistributionPointsReconciliation',
      meta: {
        title: '积分对账',
        icon: ''
      }
    }, {
      path: 'commissions',
      component: function component() {
        return import('@/views/distribution/alliance/commission/index');
      },
      name: 'DistributionCommissionDetails',
      meta: {
        title: '分账明细',
        icon: ''
      }
    }]
  },
  // 门店账号只看本门店绑定团长的数据，后端按登录账号推出团长，不接受前端传 uid
  {
    path: 'store-leader/performance',
    component: function component() {
      return import('@/views/distribution/storeLeader/performance/index');
    },
    name: 'DistributionStoreLeaderPerformance',
    meta: {
      title: '团长业绩',
      icon: ''
    }
  }, {
    path: 'store-leader/account',
    component: function component() {
      return import('@/views/distribution/storeLeader/account/index');
    },
    name: 'DistributionStoreLeaderAccount',
    meta: {
      title: '提现明细',
      icon: ''
    }
  }, {
    path: 'store-leader/verify',
    component: function component() {
      return import('@/views/distribution/storeLeader/verify/index');
    },
    name: 'DistributionStoreLeaderVerify',
    meta: {
      title: '积分核销记录',
      icon: ''
    }
  }, {
    path: 'store-coupon',
    component: function component() {
      return import('@/views/distribution/storeCoupon/index');
    },
    name: 'DistributionStoreCoupon',
    meta: {
      title: '门店优惠券',
      icon: ''
    }
  }, {
    path: 'store-refund',
    component: function component() {
      return import('@/views/distribution/storeRefund/index');
    },
    name: 'DistributionStoreRefund',
    meta: {
      title: '售后管理',
      icon: ''
    }
  }, {
    path: 'store-library',
    component: function component() {
      return import('@/views/distribution/storeLibrary/index');
    },
    name: 'DistributionStoreLibrary',
    meta: {
      title: '门店专区',
      icon: ''
    }
  }, {
    path: 'store-brand',
    component: function component() {
      return import('@/views/distribution/storeBrand/index');
    },
    name: 'DistributionStoreBrand',
    meta: {
      title: '品牌管理',
      icon: ''
    }
  }, {
    path: 'store-guarantee',
    component: function component() {
      return import('@/views/distribution/storeGuarantee/index');
    },
    name: 'DistributionStoreGuarantee',
    meta: {
      title: '保障服务',
      icon: ''
    }
  }, {
    path: 'store-reply',
    component: function component() {
      return import('@/views/distribution/storeReply/index');
    },
    name: 'DistributionStoreReply',
    meta: {
      title: '商品评论',
      icon: ''
    }
  }, {
    path: 'store-rule',
    component: function component() {
      return import('@/views/distribution/storeRule/index');
    },
    name: 'DistributionStoreRule',
    meta: {
      title: '商品规格',
      icon: ''
    }
  }, {
    path: 'overview',
    component: function component() {
      return import('@/views/distribution/overview/index');
    },
    name: 'DistributionOverview',
    meta: {
      title: '淘客概况',
      icon: ''
    }
  },
  // 门店自营商品：门店自己建自己卖，跟商城商户的商品是两套数据
  {
    path: 'store-info',
    component: function component() {
      return import('@/views/distribution/storeInfo/index');
    },
    name: 'DistributionStoreInfo',
    meta: {
      title: '门店信息',
      icon: ''
    }
  }, {
    path: 'store-contract',
    component: function component() {
      return import('@/views/distribution/storeContract/index');
    },
    name: 'DistributionStoreContract',
    meta: {
      title: '我的合同',
      icon: ''
    }
  }, {
    path: 'store-product',
    component: function component() {
      return import('@/views/distribution/storeProduct/index');
    },
    name: 'DistributionStoreProduct',
    meta: {
      title: '门店商品',
      icon: ''
    }
  }, {
    path: 'store-order',
    component: function component() {
      return import('@/views/distribution/storeOrder/index');
    },
    name: 'DistributionStoreOrder',
    meta: {
      title: '门店订单',
      icon: ''
    }
  },
  // 门店卡券：核销台 / 核销记录 / 已售卡券 / 核销员，走 distribution:store:card:*
  {
    path: 'store-card',
    component: function component() {
      return import('@/views/distribution/storeCard/index');
    },
    name: 'DistributionStoreCard',
    meta: {
      title: '门店卡券',
      icon: ''
    }
  },
  // 门店优惠券：门店自己的「全店通用」券，跟商户优惠券是两套数据
  {
    path: 'store-coupon',
    component: function component() {
      return import('@/views/distribution/storeCoupon/index');
    },
    name: 'DistributionStoreCoupon',
    meta: {
      title: '门店优惠券',
      icon: ''
    }
  }, {
    path: 'store-category',
    component: function component() {
      return import('@/views/distribution/storeCategory/index');
    },
    name: 'DistributionStoreCategory',
    meta: {
      title: '门店商品分类',
      icon: ''
    }
  }, {
    path: 'distributor',
    name: 'DistributorManage',
    meta: {
      title: '淘客商管理',
      icon: ''
    },
    children: [{
      path: 'pending',
      component: function component() {
        return import('@/views/distribution/distributor/pending/index');
      },
      name: 'DistributorPending',
      meta: {
        title: '待审核',
        icon: ''
      }
    }, {
      path: 'all',
      component: function component() {
        return import('@/views/distribution/distributor/all/index');
      },
      name: 'DistributorAll',
      meta: {
        title: '全部淘客商',
        icon: ''
      }
    }]
  }, {
    path: 'level',
    component: function component() {
      return import('@/views/distribution/level/index');
    },
    name: 'DistributionLevel',
    meta: {
      title: '淘客等级',
      icon: ''
    }
  },
  // 「淘客商品」是商户端（按 mer_id 配佣金）的功能，淘客账号没有商户身份，
  // 打开原页面只会连着弹「当前账号不是商户账号」。淘客这条线的商品走门店维度，
  // 所以这里换成一页说明 + 跳转，不再挂商户端的组件。
  {
    path: 'goods',
    component: function component() {
      return import('@/views/distribution/goodsMoved/index');
    },
    name: 'DistributionGoods',
    meta: {
      title: '淘客商品',
      icon: ''
    }
  }, {
    path: 'order',
    component: function component() {
      return import('@/views/distribution/order/index');
    },
    name: 'DistributionOrder',
    meta: {
      title: '淘客订单',
      icon: ''
    }
  }, {
    path: 'withdraw',
    component: function component() {
      return import('@/views/distribution/withdraw/index');
    },
    name: 'DistributionWithdraw',
    meta: {
      title: '淘客提现',
      icon: ''
    }
  }, {
    path: 'setting',
    name: 'DistributionSetting',
    meta: {
      title: '淘客设置',
      icon: ''
    },
    children: [{
      path: 'basic',
      component: function component() {
        return import('@/views/distribution/setting/basic/index');
      },
      name: 'DistributionBasicSetting',
      meta: {
        title: '基础设置',
        icon: ''
      }
    }, {
      path: 'agreement',
      component: function component() {
        return import('@/views/distribution/setting/agreement/index');
      },
      name: 'DistributionAgreement',
      meta: {
        title: '申请协议',
        icon: ''
      }
    }, {
      path: 'withdrawConfig',
      component: function component() {
        return import('@/views/distribution/setting/withdrawConfig/index');
      },
      name: 'DistributionWithdrawSetting',
      meta: {
        title: '提现设置',
        icon: ''
      }
    }, {
      path: 'text',
      component: function component() {
        return import('@/views/distribution/setting/text/index');
      },
      name: 'DistributionTextSetting',
      meta: {
        title: '文字设置',
        icon: ''
      }
    }]
  }]
};
export default distributionRouter;